import { Label } from '@/components/ui/label';

import { Input } from '@/components/ui/input';

import CopyIconButton from '@/components/ui/copy-to-clipboard/copy-icon-button';
import { fTokenServerless } from '@/utils/formatLabel';
import { useServerlessStore } from '@/store/serverless';

const DisplayToken = () => {
  const { token } = useServerlessStore();

  return (
    <div>
      <Label className="">Auth Token</Label>
      <p className="my-2 text-xs text-muted-foreground">
        Grant access to actions in your CLI.
      </p>
      <div className="flex items-center gap-1.5">
        <div className="w-full max-w-md">
          <Input
            value={token ? fTokenServerless(token) : ''}
            readOnly
            endIcon={<CopyIconButton text={token || ''} />}
          />
        </div>
      </div>
    </div>
  );
};

export default DisplayToken;
